module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-heart-bb607ce2230ad95f12fd117b2a0a97e9.svg";